import React from 'react';
import NiceInputPassword from 'react-nice-input-password';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import { Lock } from '@mui/icons-material';
import { withStyles } from 'tss-react/mui';
import { red, deepOrange, yellow, green, grey } from '@mui/material/colors';
import {
  getSecurityLevelsConfig
} from '@lba-dev/package.local-globals/passwordValidation';

const styles = {
  divStyle: {
    width: '45%',
    margin: '0 2.5%',
  },
};

const levelBarCss = (level) => ({
  height: '8px',
  width: level > 0 ? `${(100 / 4) * level}%` : '100%',
  marginTop: 16,
  transition: 'width 0.5s ease',
  backgroundColor: [
    grey[500],
    red[500],
    deepOrange[500],
    yellow[500],
    green[500],
  ][level],
  borderRadius: 0,
});

const CustomLevelBar = (levels) => <div style={levelBarCss(levels)} />;

const CustomPasswordInput = ({
  value = '',
  onChange,
  label = 'My password field',
  classes,
  showSecurityLevelDescription = false,
  showSecurityLevelBar = false,
}) => (
  <div className={classes.divStyle}>
    <NiceInputPassword
      value={value}
      showSecurityLevelBar={showSecurityLevelBar}
      onChange={onChange}
      InputComponent={TextField}
      showSecurityLevelDescription={showSecurityLevelDescription}
      InputComponentProps={{
        fullWidth: true,
        label,
        InputProps: {
          endAdornment: <Lock />,
        },
        autocomplete: 'new-password',
      }}
      securityLevels={getSecurityLevelsConfig().map(level => ({
        ...level,
        descriptionLabel: <Typography>{level.descriptionLabel}</Typography>
      }))}
      renderLevelBarComponent={CustomLevelBar}
    />
  </div>
);

export default withStyles(CustomPasswordInput, styles);
